import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import {
	PARAM_LABEL_BENEFICIAIRE,
	PARAM_LABEL_INTERVENANT,
	PARAM_LABEL_INTERVENTION
} from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { User } from 'src/app/shared/models/security/user';
import { Authority } from 'src/app/shared/models/security/authority';

@Component({
	selector: 'app-nav-gestion-donnees',
	templateUrl: './nav-gestion-donnees.component.html',
	styleUrls: ['./nav-gestion-donnees.component.scss']
})
export class NavGestionDonneesComponent implements OnInit {
	tabs: any[];
	detailTab: any;

	@Input() addable = false;
	@Input() isImportable = false;
	@Input() isExportable = false;
	@Output() importingEvent: EventEmitter<MouseEvent> =
		new EventEmitter<MouseEvent>();
	@Output() exportingEvent: EventEmitter<MouseEvent> =
		new EventEmitter<MouseEvent>();
	@Output() addEvent: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

	user: User;

	constructor(private router: Router, private facade: FacadeService) {}

	ngOnInit(): void {
		this.user = this.facade.dataStorageService.getUser();
		this.initializeTabs();
	}

	private initializeTabs(): void {
		this.tabs = [];

		const labelIntervention = this.facade.dataStorageService.getLabel(
			PARAM_LABEL_INTERVENTION
		);

		this.addCommonTabs(labelIntervention);
		this.addSpecializedTabs(labelIntervention);
	}

	private addCommonTabs(labelIntervention: string): void {
		if (
			this.hasPlanificatorAuthority() &&
			(this.facade.dataStorageService.isSAAD() ||
				this.facade.dataStorageService.isSESSAD() ||
				this.facade.dataStorageService.isSAE())
		) {
			this.addToTabs('Expertises', '/gestion/expertises');
			this.addToTabs('Spécialités', '/gestion/specialites');
			this.addToTabs('Types de ' + labelIntervention, '/gestion/mission/type');

			if (this.facade.dataStorageService.isFunderActive()) {
				this.addToTabs('Financeurs', '/gestion/funders');
			}
		}

		if (
			this.facade.dataStorageService.isAreaActive() &&
			this.hasPlanificatorAuthority()
		) {
			this.addToTabs('Secteurs', '/gestion/areas');
		}

		if (
			this.facade.dataStorageService.isSAE() &&
			this.hasPlanificatorAuthority()
		) {
			this.addToTabs('Services', '/gestion/services');
		}

		if (
			this.facade.dataStorageService.isVehiculeActive() &&
			this.hasPlanificatorAuthority()
		) {
			this.addToTabs('Véhicules', '/gestion/vehicules');
		}
	}

	private addSpecializedTabs(labelIntervention: string): void {
		if (
			this.hasPlanificatorAuthority() &&
			this.facade.dataStorageService.isSAE()
		) {
			this.addToTabs('Dossiers', '/gestion/parcours');
		}

		if (
			(this.hasChargeMissionAuthority() ||
				this.hasProfessionnelSAEAuthority()) &&
			(this.facade.dataStorageService.isSESSAD() ||
				this.facade.dataStorageService.isSAE())
		) {
			this.addToTabs(
				'Lieux de ' + labelIntervention,
				'/gestion/mission-places'
			);
		}

		if (this.hasPlanificatorAuthority()) {
			this.addToTabs(
				this.facade.dataStorageService.getLabelCapitalizedPluralized(
					PARAM_LABEL_INTERVENANT
				),
				'/gestion/employees'
			);
		}

		if (this.hasChargeMissionAuthority()) {
			this.addToTabs(
				this.facade.dataStorageService.getLabelCapitalizedPluralized(
					PARAM_LABEL_BENEFICIAIRE
				),
				'/gestion/beneficiaires'
			);
		}
		if (
			this.hasChargeMissionAuthority() ||
			this.hasProfessionnelSAEAuthority()
		) {
			this.addToTabs(
				this.facade.dataStorageService.getLabelCapitalizedPluralized(
					PARAM_LABEL_INTERVENTION
				),
				'/gestion/formations'
			);
		}
	}

	private hasPlanificatorAuthority(): boolean {
		return this.userAsAnyAuthority([
			Authority.DIRECTEUR_STRUCTURE,
			Authority.RESPONSABLE_CENTRE,
			Authority.PLANIFICATEUR
		]);
	}

	private hasChargeMissionAuthority(): boolean {
		return this.userAsAnyAuthority([
			Authority.DIRECTEUR_STRUCTURE,
			Authority.RESPONSABLE_CENTRE,
			Authority.PLANIFICATEUR,
			Authority.CHARGE_MISSION
		]);
	}

	private hasProfessionnelSAEAuthority(): boolean {
		return this.userAsAnyAuthority([
			Authority.DIRECTEUR_STRUCTURE,
			Authority.RESPONSABLE_CENTRE,
			Authority.PLANIFICATEUR,
			Authority.PROFESSIONNEL_SAE
		]);
	}

	private addToTabs(name: string, path: string): void {
		this.tabs.push({ name, path: `${path}/list`, parentPath: path });
	}

	scrollTop() {
		window.scroll(0, 0);
	}

	userAsAnyAuthority(listAuthority: Authority[]) {
		return listAuthority.some((authority) => authority === this.user?.role.id);
	}

	isRouterActive(path: string) {
		return this.router.isActive(path, false);
	}

	isRouterActiveForChild(path: string) {
		return this.router.isActive(path, false);
	}

	shouldShowDropdown(): boolean {
		const currentPath = this.router.url;
		return (
			this.facade.dataStorageService.isSAE() &&
			currentPath.includes('gestion/formations/list')
		);
	}
}
